import { lazy } from 'react';

const DiscountApprovalPage = lazy(() => import('./components/DiscountApprovalPage'));

const DiscountApprovalConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: 'discountApproval',
            element: <DiscountApprovalPage />,
        },
    ],
};

export default DiscountApprovalConfig;